import { render, staticRenderFns } from "./PollQuestionsView.vue?vue&type=template&id=2b88c748&scoped=true&"
import script from "./PollQuestionsView.vue?vue&type=script&lang=ts&"
export * from "./PollQuestionsView.vue?vue&type=script&lang=ts&"
import style0 from "./PollQuestionsView.vue?vue&type=style&index=0&id=2b88c748&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b88c748",
  null
  
)

export default component.exports